"use client";

import { Button } from "@tracify/ui/button";

export function DashboardRouteError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="flex min-h-[40vh] w-full items-center justify-center px-4 text-foreground">
      <div className="flex max-w-md flex-col items-center gap-4 rounded-lg border border-border bg-card p-6 text-center shadow-sm">
        <div>
          <h2 className="text-lg font-semibold">
            This page couldn&apos;t load
          </h2>
          <p className="mt-1 text-sm text-muted-foreground">
            {error.message || "An unexpected dashboard error occurred."}
          </p>
        </div>
        <Button type="button" variant="primary" onClick={reset}>
          Try again
        </Button>
      </div>
    </div>
  );
}
